/*
This file is for handle Recorder.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 07/12/2017 12:05 PM
*/
/* global document */

import Element from './../Element';
import View from './../View';


const Share = (spec) => {
  const view = View({});
  const that = {};
  that.stream = spec.stream;
  that.share = Element({ name: 'i', title: 'share screen', class: `fa fa-share-alt fa-fw fa-lg icon_share ${spec.skin}_icon ${spec.skin}_icon_share` });
  that.share.onclick = function (e) { Share.click(e, that.stream); };
  return that.share;
};
Share.click = function (e, stream) {
  const streamShare = VcxRtc.Stream({ screen: true, data: true, attributes: { name: 'shareStream' } });
  streamShare.init();
  streamShare.addEventListener('media-access-allowed', () => {
    stream.room.publish(streamShare, { maxVideoBW: 300 }, (id, error) => {
    });
  });
  streamShare.addEventListener('media-access-denied', (error) => {
  });
};
export default Share;



//////////////////
// WEBPACK FOOTER
// ./src/views/component/Share.js
// module id = 185
// module chunks = 0